import React, { useState, useEffect, useContext, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import DivLayout from "components/sales/divLayout/divLayout";
import CardSection from "components/sales/cardSection/cardSection";
import DocumentView from "components/sales/downloadDocView/documentView";
import ModalPop from "components/sales/modal/modal";
import ReactStars from "react-rating-stars-component";
import TextAreaInput from "components/sales/Input/textAreaInput/textAreaInput";
import { toast } from "react-toastify";

const MeetingView = ({
  match,
  userDataByUserId,
  userMeetingDetailsByUserId = [],
  saveTheMeetingRating,
  saveMeetingRatingByImmediateSenior = [],
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [inputFields, setInputFields] = useState({ rating: "", remark: "" });
  const [meetingId, setMeetingId] = useState(null);

  useEffect(() => {
    (async () => {
      if (match?.params?.id) {
        setIsLoading(true);
        await userDataByUserId(null, match?.params?.id);
        setIsLoading(false);
      }
    })();
  }, []);

  const handleRating = async () => {
    setIsModal(true);
    setMeetingId(match?.params?.id);
  };

  const handleModalHide = () => {
    setIsModal(false);
  };

  const handleSubmit = async () => {
    const payload = {
      meeting_id: meetingId,
      rating: inputFields?.rating,
      rating_remark: inputFields?.remark,
    };
    setIsLoading(true);
    const res = await saveTheMeetingRating(payload);
    if (res?.status === 200) {
      setIsModal(false);
      toast.success(res.message);
    } else {
      toast.error(res.message);
    }
    setIsLoading(false);
  };

  return (
    <Layout
      title={"Meeting Details"}
      isGoback
      isLoading={isLoading}
      linkFlag
      linkUrl={`${baseUrl}/brand-activation/meetings-rating`}
    >
      {userMeetingDetailsByUserId && userMeetingDetailsByUserId.length > 0 ? (
        userMeetingDetailsByUserId.map((details, index) => (
          <div key={index} className="panel-card">
            <div className="panel-heading">
              {`${localization.meetingDetails}`}
            </div>

            <div className="panel-body">
              <div className="details-listing">
                <DivLayout
                  heading={"Client Name"}
                  data={
                    details?.client_name ? `${details.client_name}` : "Others"
                  }
                />
                <DivLayout
                  heading={"Site Id"}
                  data={details?.site_id ? `${details.site_id}` : "N/A"}
                />
                <DivLayout
                  heading={"Site No."}
                  data={details?.site_no ? `${details.site_no}` : "N/A"}
                />
                <DivLayout
                  heading={"Scheduled Date"}
                  data={
                    details?.scheduled_date
                      ? `${details.scheduled_date}`
                      : "N/A"
                  }
                />
                <DivLayout
                  heading={"Meeting Type"}
                  data={details?.eng_at ? `${details.eng_at}` : "N/A"}
                />
                <DivLayout
                  heading={"Subject"}
                  data={details?.subject ? `${details.subject}` : "N/A"}
                />
                <DivLayout
                  heading={"Body"}
                  data={details?.body ? `${details.body}` : "N/A"}
                />
                <DivLayout
                  heading={"Remark"}
                  data={details?.remark ? `${details.remark}` : "N/A"}
                />
                <DivLayout
                  heading={"Comment"}
                  data={details?.comments ? `${details.comments}` : "N/A"}
                />
                {details.rating && (
                  <DivLayout
                    heading={"Rating by immediate senior"}
                    data={details?.rating ? `${details.rating}` : "N/A"}
                  />
                )}
                {details.rating_remark && (
                  <DivLayout
                    heading={"Remark by immediate senior"}
                    data={
                      details?.rating_remark
                        ? `${details.rating_remark}`
                        : "N/A"
                    }
                  />
                )}
                {details.rated_by_email && (
                  <DivLayout
                    heading={"Rated by email"}
                    data={
                      details?.rated_by_email
                        ? `${details.rated_by_email}`
                        : "N/A"
                    }
                  />
                )}
                {details.rated_by_name && (
                  <DivLayout
                    heading={"Rated by name"}
                    data={
                      details?.rated_by_name
                        ? `${details.rated_by_name}`
                        : "N/A"
                    }
                  />
                )}

                <DocumentView
                  title={localization.attachment}
                  attachment={details?.attachment}
                />
                {details?.details ? (
                  JSON.parse(details.details).map((momItem, momIndex) => (
                    <div key={index} className="panel-card">
                      <div className="panel-heading">{`${"MOM Details"}`}</div>
                      <div className="panel-body">
                        <div key={momIndex} className="details-listing">
                          <DivLayout
                            heading={"Agenda"}
                            data={momItem.agenda ? `${momItem.agenda}` : "N/A"}
                          />
                          <DivLayout
                            heading={"Timeline"}
                            data={
                              momItem.timeline ? `${momItem.timeline}` : "N/A"
                            }
                          />
                          <DivLayout
                            heading={"Responsibility"}
                            data={
                              momItem.responsibility
                                ? `${momItem.responsibility}`
                                : "N/A"
                            }
                          />
                          <DivLayout
                            heading={"Description"}
                            data={
                              momItem.description
                                ? `${momItem.description}`
                                : "N/A"
                            }
                          />
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div key={index} className="panel-card">
                    <div className="panel-heading">{`${"MOM Details"}`}</div>
                    <div className="panel-body">
                      <div className="details-listing">
                        <DivLayout heading={"Agenda"} data={"N/A"} />
                        <DivLayout heading={"Timeline"} data={"N/A"} />
                        <DivLayout heading={"Responsibility"} data={"N/A"} />
                        <DivLayout heading={"Description"} data={"N/A"} />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
            { !details.rating && (
              <div className="col-md-3 mb-4 d-flex">
                <button className="btn btn-success" onClick={handleRating}>Rate</button>
              </div>
            )}
          </div>
        ))
      ) : (
        <div>
          <img src={Images?.NoData} alt="No Data Found" width="100%" />
        </div>
      )}

      <ModalPop
        title={"Rate Meeting"}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="d-flex" style={{ justifyContent: "center" }}>
            <ReactStars
              count={5}
              onChange={(val) =>
                setInputFields({ ...inputFields, rating: val })
              }
              size={40}
              activeColor="#ffd700"
            />
          </div>
          <div className="col-md-12">
            <TextAreaInput
              inputValue={
                inputFields?.remark !== null ? inputFields?.remark : ""
              }
              className={`${
                !inputFields.remark && "empty"
              } inline-css scrollbar-styling`}
              rows={4}
              type="text"
              label={localization.remark}
              required
              isStarRequired={true}
              errorMsg={localization.isRequired}
              handleChange={(e) =>
                setInputFields({ ...inputFields, remark: e.target.value })
              }
            />
          </div>
          <div className="col-md-3">
            <button className="btn btn-success" onClick={handleSubmit}>
              Rate
            </button>
          </div>
        </div>
      </ModalPop>
    </Layout>
  );
};

export default MeetingView;
